// レベルアップの選択肢(カード)に添える絵(2026-11-01 オーナー要望「カードが文字だけでイメージがわかない」)。
// 絵はここに SVG の文字列で持つ(画像ファイルを増やさない・拡大しても粗くならない・色をゲームと合わせやすい)。
// 色はゲームの中の見た目に合わせる: 武器の弾は寒色(ビーム=青・拡散=水色・ミサイル/サーベル=紫)、経験値=金、修理=緑、SHIELD=青。
// 進化した武器は、同じ武器の絵を派手にした別の絵 + 金のにじみ(金の枠は style.css の .choice.evolve .icon)。
// 武器・強化を足したら、ここにも絵を足す(tests/icons.test.js が抜けを調べる)。

// 絵の部品(viewBox 0 0 48 48。中心 24,24)
const glow = (id, color) => `<radialGradient id="${id}"><stop offset="0" stop-color="${color}" stop-opacity="0.55"/><stop offset="1" stop-color="${color}" stop-opacity="0"/></radialGradient>`;
const ring = (n, r, draw) => Array.from({ length: n }, (_, i) => draw((i / n) * Math.PI * 2, r)).join("");
const pt = (a, r) => [24 + Math.cos(a) * r, 24 + Math.sin(a) * r].map((v) => v.toFixed(1));

// 武器(id → 絵)。color は背景のにじみの色
const WEAPON_ART = {
  beam: {
    color: "#2f8cff",
    art: `<circle cx="34" cy="14" r="7" fill="none" stroke="#ff5a7a" stroke-width="1.5" stroke-dasharray="3 2.5"/>
      <line x1="8" y1="40" x2="31" y2="17" stroke="#2f8cff" stroke-width="6" stroke-linecap="round" opacity="0.8"/>
      <line x1="8" y1="40" x2="31" y2="17" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/>
      <line x1="14" y1="42" x2="26" y2="30" stroke="#2f8cff" stroke-width="4" stroke-linecap="round" opacity="0.7"/>
      <line x1="14" y1="42" x2="26" y2="30" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/>`,
  },
  spread: {
    color: "#3fd8ff",
    art:
      `<circle cx="24" cy="24" r="4" fill="#fff"/>` +
      ring(8, 0, (a) => {
        const [x1, y1] = pt(a, 9), [x2, y2] = pt(a, 18);
        return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="#3fd8ff" stroke-width="5" stroke-linecap="round" opacity="0.75"/><line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/>`;
      }),
  },
  missile: {
    color: "#a77bff",
    art: `<path d="M6 42 Q 10 26 22 22" fill="none" stroke="#c9b0ff" stroke-width="3" stroke-linecap="round" stroke-dasharray="1 4" opacity="0.9"/>
      <g transform="rotate(-40 30 18)"><rect x="20" y="15" width="14" height="6" rx="1.5" fill="#d8ccff"/><path d="M34 15 L41 18 L34 21 Z" fill="#fff"/><path d="M20 15 L16 11 L23 15 Z M20 21 L16 25 L23 21 Z" fill="#a77bff"/><path d="M20 16.5 L13 18 L20 19.5 Z" fill="#ffd080"/></g>
      <circle cx="40" cy="8" r="3.5" fill="#ffb040" opacity="0.9"/>`,
  },
  saber: {
    color: "#8a7dff",
    art: `<path d="M24 20 L28 28 L24 26 L20 28 Z" fill="#e8f1ff"/>
      <circle cx="24" cy="24" r="15" fill="none" stroke="#8a7dff" stroke-width="1" stroke-dasharray="2 3" opacity="0.7"/>
      <path d="M10 18 A15 15 0 0 1 22 9" fill="none" stroke="#8a7dff" stroke-width="6" stroke-linecap="round" opacity="0.8"/>
      <path d="M10 18 A15 15 0 0 1 22 9" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
      <path d="M38 30 A15 15 0 0 1 26 39" fill="none" stroke="#8a7dff" stroke-width="6" stroke-linecap="round" opacity="0.8"/>
      <path d="M38 30 A15 15 0 0 1 26 39" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>`,
  },
  mainGun: {
    color: "#4fb4ff",
    art: `<rect x="17" y="4" width="14" height="32" rx="7" fill="#4fb4ff" opacity="0.55"/>
      <rect x="21" y="4" width="6" height="32" rx="3" fill="#fff"/>
      <path d="M16 44 L24 34 L32 44 Z" fill="#e8f1ff"/><circle cx="24" cy="36" r="5" fill="#ff6a3a" opacity="0.8"/>`,
  },
};

// 進化した武器の絵(同じ武器を派手にしたもの)
const EVO_ART = {
  beam: `<circle cx="36" cy="12" r="8" fill="none" stroke="#ff5a7a" stroke-width="1.5" stroke-dasharray="3 2.5"/>
    ${[[4, 36], [10, 42], [16, 46]].map(([x, y]) => `<line x1="${x}" y1="${y}" x2="${x + 26}" y2="${y - 26}" stroke="#2f8cff" stroke-width="7" stroke-linecap="round" opacity="0.75"/><line x1="${x}" y1="${y}" x2="${x + 26}" y2="${y - 26}" stroke="#fff" stroke-width="2.6" stroke-linecap="round"/>`).join("")}`,
  spread:
    `<circle cx="24" cy="24" r="5" fill="#fff"/>` +
    ring(12, 0, (a) => {
      const [x1, y1] = pt(a, 8), [x2, y2] = pt(a, 14);
      const [x3, y3] = pt(a + 0.26, 16), [x4, y4] = pt(a + 0.26, 21);
      return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="#3fd8ff" stroke-width="3.5" stroke-linecap="round"/><line x1="${x3}" y1="${y3}" x2="${x4}" y2="${y4}" stroke="#fff" stroke-width="2" stroke-linecap="round"/>`;
    }),
  missile: [[-40, 26, 20], [-20, 34, 30], [-60, 18, 30]]
    .map(([r, x, y]) => `<g transform="translate(${x - 28} ${y - 18}) rotate(${r} 28 18)"><rect x="20" y="16" width="11" height="5" rx="1.2" fill="#d8ccff"/><path d="M31 16 L36 18.5 L31 21 Z" fill="#fff"/><path d="M20 17 L14 18.5 L20 20 Z" fill="#ffd080"/></g>`)
    .join("") + `<circle cx="38" cy="10" r="6" fill="#ffb040" opacity="0.85"/><circle cx="38" cy="10" r="3" fill="#fff"/>`,
  saber:
    `<path d="M24 20 L28 28 L24 26 L20 28 Z" fill="#e8f1ff"/>` +
    ring(4, 17, (a, r) => {
      const [x1, y1] = pt(a, r), [x2, y2] = pt(a + 0.9, r);
      const d = `M${x1} ${y1} A${r} ${r} 0 0 1 ${x2} ${y2}`;
      return `<path d="${d}" fill="none" stroke="#8a7dff" stroke-width="6" stroke-linecap="round" opacity="0.85"/><path d="${d}" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>`;
    }),
  mainGun: `<circle cx="24" cy="18" r="13" fill="none" stroke="#4fb4ff" stroke-width="2" opacity="0.6"/>
    <circle cx="24" cy="18" r="8.5" fill="none" stroke="#a77bff" stroke-width="2.5" stroke-dasharray="7 3"/>
    <circle cx="24" cy="18" r="5" fill="#0a0420" stroke="#fff" stroke-width="1.5"/>
    <path d="M16 46 L24 36 L32 46 Z" fill="#e8f1ff"/><rect x="22" y="30" width="4" height="7" fill="#fff"/>`,
};

// 自機の強化
const PASSIVE_ART = {
  power: {
    color: "#ff9a00",
    art: `<path d="M27 4 L12 27 L22 27 L18 44 L36 19 L25 19 Z" fill="#ffd23a" stroke="#ff9a00" stroke-width="2" stroke-linejoin="round"/>`,
  },
  haste: {
    color: "#49e6ff",
    art: `<circle cx="22" cy="27" r="14" fill="none" stroke="#e8f1ff" stroke-width="3"/><rect x="19" y="7" width="6" height="5" rx="1" fill="#e8f1ff"/>
      <path d="M22 27 L22 17" stroke="#49e6ff" stroke-width="3" stroke-linecap="round"/><path d="M22 27 L29 31" stroke="#49e6ff" stroke-width="3" stroke-linecap="round"/>
      <path d="M36 14 l6 0 M38 20 l6 0 M36 26 l6 0" stroke="#49e6ff" stroke-width="2.5" stroke-linecap="round"/>`,
  },
  thruster: {
    color: "#49e6ff",
    art: `<path d="M24 4 L33 24 L24 21 L15 24 Z" fill="#e8f1ff"/>
      <path d="M18 24 Q24 46 30 24 Z" fill="#49e6ff" opacity="0.85"/><path d="M21 24 Q24 36 27 24 Z" fill="#fff"/>
      <path d="M6 30 l5 -5 l5 5 M6 38 l5 -5 l5 5 M32 30 l5 -5 l5 5 M32 38 l5 -5 l5 5" fill="none" stroke="#49e6ff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>`,
  },
  magnet: {
    color: "#ffd23a",
    art: `<path d="M8 30 L8 18 A10 10 0 0 1 28 18 L28 30" fill="none" stroke="#ff5a7a" stroke-width="7"/>
      <path d="M8 30 L8 36 M28 30 L28 36" stroke="#e8f1ff" stroke-width="7"/>
      ${[[38, 12, 4], [40, 26, 3.2], [36, 40, 3.6]].map(([x, y, s]) => `<polygon points="${x},${y - s} ${x + s * 0.7},${y} ${x},${y + s} ${x - s * 0.7},${y}" fill="#ffd23a" stroke="#ff9a00" stroke-width="1"/>`).join("")}`,
  },
  shield: {
    color: "#2f8cff",
    art: `<path d="M24 4 L40 10 L40 24 Q40 38 24 45 Q8 38 8 24 L8 10 Z" fill="#2f8cff" fill-opacity="0.35" stroke="#8fe6ff" stroke-width="2.5" stroke-linejoin="round"/>
      <path d="M24 16 L24 32 M16 24 L32 24" stroke="#fff" stroke-width="4" stroke-linecap="round"/>`,
  },
};

// SHIELD回復(画面の修理アイテムと同じ緑の十字)
const HEAL_ART = {
  color: "#4dff7a",
  art: `<rect x="6" y="6" width="36" height="36" rx="5" fill="none" stroke="#1fcc55" stroke-width="2"/><path d="M19 11h10v8h8v10h-8v8h-10v-8h-8v-10h8z" fill="#4dff7a"/>`,
};

let uid = 0;
function svg(color, art, gold) {
  const g = `ig${++uid}`; // にじみの id(同じ画面に何枚も出るので、毎回変える)
  return `<svg viewBox="0 0 48 48" aria-hidden="true"><defs>${glow(g, gold ? "#ffd23a" : color)}</defs><circle cx="24" cy="24" r="24" fill="url(#${g})"/>${art}</svg>`;
}

// 選択肢(src/sim/upgrades.js の rollChoices が作るもの)の絵。SVG の文字列
export function choiceIcon(choice) {
  if (choice.kind === "weapon") return svg(WEAPON_ART[choice.id].color, WEAPON_ART[choice.id].art);
  if (choice.kind === "evolve") return svg(WEAPON_ART[choice.id].color, EVO_ART[choice.id], true);
  if (choice.kind === "passive") return svg(PASSIVE_ART[choice.id].color, PASSIVE_ART[choice.id].art);
  return svg(HEAL_ART.color, HEAL_ART.art);
}

// テスト用: 絵がある id
export const ICON_IDS = { weapon: Object.keys(WEAPON_ART), evolve: Object.keys(EVO_ART), passive: Object.keys(PASSIVE_ART) };
